/* eslint-disable no-unused-vars */

import { stokpressViewPort } from '../util/helper';
/* eslint-disable no-undef */

var ImageSwitch = {};
ImageSwitch.init = function () {
  var images = document.querySelectorAll('.js-image-switch');
  if (images.length === 0) {
    return;
  }
  for (var i = 0; i < images.length; i++) {
    ImageSwitch.changeImage(images[i]);
  }
};
ImageSwitch.updateElement = function (type, element, src) {
  if (!src) src = window.sitewide.imagePlaceholder || '';
  if (element.classList.contains('lazy') && window.lazyLoadInstance != undefined) {
    element.setAttribute('data-bg', 'url(' + src + ')');
    element.setAttribute('data-was-processed', 'false');
    window.lazyLoadInstance.update();
  } else if (type === 'backgroundImage') {
    element.style.backgroundImage = 'url(' + src + ')';
  } else {
    element.src = src;
  }
};
ImageSwitch.changeImage = function (element) {
  if (!element) {
    return;
  }
  var desktopBanner = element.getAttribute('data-desktop-background'),
    mobileBanner = element.getAttribute('data-mobile-background'),
    type = element.dataset.type;
  if (mobileBanner) {
    if (stokpressViewPort.documentWidth().width < 767) {
      ImageSwitch.updateElement(type, element, mobileBanner);
    } else {
      ImageSwitch.updateElement(type, element, desktopBanner);
    }
  } else {
    ImageSwitch.updateElement(type, element, desktopBanner);
  }
};
document.addEventListener('DOMContentLoaded', function () {
  ImageSwitch.init();
});
window.addEventListener('resize', function () {
  ImageSwitch.init();
});
window.ImageSwitch = ImageSwitch;


// WEBPACK FOOTER //
// ./scripts/components/image-switcher.js